export const planSeed = [
  {
    id: 1,
    name: 'Basic Plan',
    price: 1,
    coins: 15_000,
  },
  {
    id: 2,
    name: 'Free Plan',
    price: 0,
    coins: 100,
  },
] as const
